import React, { useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import { FaSpinner, FaSync, FaUserPlus } from 'react-icons/fa';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import DwellerItem from './DwellerItem';
import useContext from '../../hooks/useContext';
import useShareModal from '../../hooks/useShareModal';

const listGql = gql`
  query listPendindingCondominiumUsers($condominiumId: ID!, $status: String) {
    dwellers(condominiumId: $condominiumId, status: $status) {
      _id
      name
      phoneNumber
      email
      unity(condominiumId: $condominiumId) {
        _id
        name
        status
        reason
        data
        permissions {
          vote
          comment
          view
        }
      }
    }
    condominium(condominiumId: $condominiumId) {
      _id
      dwellersCount
    }
  }
`;

function DwellersList({ condominium }) {
  const { data, loading, refetch, startPolling, stopPolling } = useQuery(listGql, {
    variables: {
      condominiumId: condominium._id,
      status: 'pending',
    },
  });

  const { isJanitor } = useContext();
  const shareModal = useShareModal();

  const pendingUsers = useMemo(() => {
    if (!data) return [];
    return data.dwellers;
  }, [data]);

  const totalUsers = useMemo(() => {
    if (!data || !data.condominium) return 0;
    return data.condominium.dwellersCount;
  }, [data]);

  const PLURALIZATION_PENDING_USERS = useMemo(() => (pendingUsers.length > 1 ? 's' : ''), [pendingUsers]);
  const PLURALIZATION_TOTAL_USERS = useMemo(() => (totalUsers > 1 ? 's' : ''), [totalUsers]);

  const handleInviteModal = async () => shareModal();

  useEffect(() => {
    if (!isJanitor) return undefined;

    const THIRTY_SECONDS = 30 * 1000;
    startPolling(THIRTY_SECONDS);
    return () => {
      stopPolling();
    };
  }, [isJanitor]);

  return (
    <div className="row">
      <div className="col">
        <div className="card mb-3">
          <div className="card-body">
            <div className="card-title d-flex justify-content-between align-items-center">
              <div>
                {`${totalUsers} condômino${PLURALIZATION_TOTAL_USERS} `}
                <Link to={`/condominiums/${condominium._id}/dwellers`}>abrir</Link>
              </div>
              <button className="btn btn-sm btn-primary" type="button" onClick={handleInviteModal}>
                + Convidar
              </button>
            </div>
            <hr />
            <div className="card-subtitle d-flex justify-content-between align-items-center">
              {loading && <FaSpinner />}
              <div>
                <FaUserPlus />
                {` ${pendingUsers.length} condômino${PLURALIZATION_PENDING_USERS} pendente${PLURALIZATION_PENDING_USERS}`}
              </div>
              <button className="float-right btn btn-outline-primary btn-sm" onClick={() => refetch()} type="button">
                <FaSync />
              </button>
            </div>
            <hr />
            {pendingUsers.map(dweller => (
              <DwellerItem dweller={dweller} key={dweller._id} onCompleted={refetch} submitOnChange />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

DwellersList.propTypes = {
  // users: propTypes.object.isRequired,
  // loading: propTypes.bool.isRequired,
  // onCompleted: propTypes.func.isRequired,
  condominium: propTypes.object.isRequired,
};

export default DwellersList;
